import { useMemoizedFn } from 'ahooks';
import { uploadFeedbackImage, deleteFeedbackImage } from '@home/services/home';

export default function useMockCOS() {
  const putObject = useMemoizedFn(
    async (payload: { path: string; file: File; onProgress: (progressData: { percent: number }) => void }) => {
      const { file, onProgress } = payload || {};
      const fd = new FormData();
      fd.append('image', file);
      return uploadFeedbackImage(fd, {
        onProgress: (e: ProgressEvent) => {
          // console.log(`percent: ${e?.loaded / e?.total} loaded: ${e?.loaded}, total: ${e?.total}`);
          onProgress?.({
            percent: e?.loaded / e?.total,
          });
        },
      });
    },
  );

  const deleteObject = useMemoizedFn(async (payload: { path?: string }) => {
    const { path } = payload || {};
    await deleteFeedbackImage({ image: path || '' });
  });

  return {
    putObject,
    deleteObject,
  };
}
